// 默认俯仰可视范围角度
export const DefaultYRange = [-86, 86];

// 默认静态可视范围角度
export const DefaultFovy = 60;

// 所有动画默认执行时间
export const DefaultAnimDuration = 500;

// 移动灵敏度
export const DefaultMovingRate = 1.5;
